import type { LeadFlowStepDefinition } from "../types";

type LeadFlowProgress = {
  /** Question steps completed or in view, from 0 to `total`. */
  position: number;
  total: number;
};

/**
 * Progress through a flow's question steps. Interstitials don't count,
 * so the position holds at the last question step while one is shown.
 */
function getProgress(
  steps: LeadFlowStepDefinition[],
  currentStepIndex: number,
): LeadFlowProgress {
  const isQuestionStep = (step: LeadFlowStepDefinition) =>
    step._type === "leadFlowStep";

  return {
    position: steps.slice(0, currentStepIndex + 1).filter(isQuestionStep)
      .length,
    total: steps.filter(isQuestionStep).length,
  };
}

export { getProgress };
